export default __webpack_public_path__ + "4f75758.png";